// Credits are whole numbers; any spend above zero shows as at least 1. Same as Ask Paul's formatCredits.js.
export const formatCredits = (n) => {
  const v = Number(n) || 0;
  return (v > 0 ? Math.max(1, Math.round(v)) : 0).toLocaleString();
};
